import { render, staticRenderFns } from "./EstateInfo1.vue?vue&type=template&id=9c0ebb86&scoped=true&"
import script from "./EstateInfo1.vue?vue&type=script&lang=js&"
export * from "./EstateInfo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0ebb86",
  null
  
)

export default component.exports